<template>
  <section class="featured-section" id="featured-project">

    <a
      :href="projectLink"
      target="_blank"
      rel="noopener noreferrer"
      class="featured-link"
      loading="lazy"
    >

      <figure class="featured">

        <img
          :src="banners.banner"
          alt="Banner Black Paladins"
          class="banner-image"
        />

      </figure>

    </a>

  </section>
</template>

<script setup>
import { projectLink, featuredProject } from "@/data/featuredProject.js"

import { computed } from "vue"
import { useI18n } from "vue-i18n"

const { locale } = useI18n()

const banners = computed(() => {

  if (locale.value === "pt") {
    return featuredProject.pt
  }

  return featuredProject.en

})
</script>

<style>
.featured-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 60px auto 80px auto;
}

.featured-link {
  display: inline-block;
}

.featured {
  width: 100%;
  display: flex;
  justify-content: center;
}

.banner-image {
  display: block;
  width: 100%;
  max-width: 1100px;
  max-height: 250px;
  height: auto;
  object-fit: contain;
  border-radius: 14px;
  box-shadow:
    0 6px 15px var(--card-sombra),
    0 0 10px var(--card-destaque);
}

@media (max-width: 1000px) {
  .featured-section {
    max-width: 350px;
    padding: 10px;
    margin: 30px 20px;
  }

  .featured {
    max-width: 350px;
    display: flex;
    justify-content: center;
  }

  .banner-image {
    max-width: 400px;
    max-height: auto;
    border-radius: 10px;
  }
}
</style>